import { Box, Link, Typography } from '@mui/material';

export default function EvSubsidyNotice(props) {
  return (
    <Box {...props}>
      <Typography component="div" sx={{ color: 'grey.700' }} variant="caption">
        <sup>III.</sup>
        {' '}
        Die staatliche E-Auto-Förderung 2026 steht Privatpersonen beim Erwerb oder Leasing
        förderfähiger Neufahrzeuge der EU-Fahrzeugklasse M1 offen, die ab dem 1. Januar 2026
        erstmals in Deutschland zugelassen werden. Förderfähig sind rein batterieelektrische
        Fahrzeuge (BEV), Elektrofahrzeuge mit Range-Extender (REEV) sowie Plug-in-Hybride
        (PHEV) mit einer elektrischen Mindestreichweite von 80 km oder einem CO₂-Ausstoß von
        max. 60 g/km (Typgenehmigungswert). Die Förderhöhe richtet sich nach dem zu
        versteuernden Haushaltsjahreseinkommen und der Anzahl minderjähriger Kinder im
        Haushalt. Voraussetzung ist eine Mindesthaltedauer von 36 Monaten. Der Förderantrag
        ist spätestens 12 Monate nach Erstzulassung über das staatliche Online-Portal
        einzureichen. Kein Rechtsanspruch. Weitere Informationen:
        {' '}
        <Link
          href="https://www.bundesumweltministerium.de/foerderung/fragen-und-antworten-zur-e-auto-foerderung"
          target="_blank"
        >
          Bundesministerium für Umwelt, Klimaschutz, Naturschutz und nukleare Sicherheit (BMUKN).
        </Link>
      </Typography>
    </Box>
  );
}
